import React, { createContext, useContext, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { translations } from "./translations";
import { pagePath, entityPath, articlePath } from "../config/pages";

const I18nContext = createContext(null);

export function detectLang(pathname) {
  if (pathname === "/fr" || pathname.startsWith("/fr/")) return "fr";
  if (pathname === "/de" || pathname.startsWith("/de/")) return "de";
  return "en";
}

export function I18nProvider({ children }) {
  const location = useLocation();
  const lang = detectLang(location.pathname);

  const value = useMemo(() => {
    const t = translations[lang] || translations.en;
    return {
      lang,
      t,
      // localized path helpers bound to current language
      p: (key) => pagePath(key, lang),
      e: (slugMap) => entityPath(null, slugMap, lang),
      a: (slugMap) => articlePath(slugMap, lang),
      // build the equivalent URL in another language for the language switcher
      switchTo: (targetLang, altMap) => {
        if (altMap && altMap[targetLang]) return altMap[targetLang];
        return pagePath("home", targetLang);
      },
    };
  }, [lang]);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
}
